import request from '@/utils/request'

export function GetSnapshotCategory(params){
  return request({
    url: 'wx/snapshot/category',
    method: 'get',
    params
  })
}
export function PostSnapshot(data){
  return request({
    url: 'wx/snapshot',
    method: 'post',
    data
  })
}

export function GetcdList(){
  return request({
    url: 'wx/article-category',
    method: 'get',
  
  })
}
export function GetquestionList(params){
  return request({
    url: 'wx/article-list',
    method: 'get',
    params
  })
}

export function GetTJ(id){
  return request({
    url: 'wx/article-up-vote/'+id,
    method: 'get',
  
  })
}

export function GetNoTJ(id){
  return request({
    url: 'wx/article-down-vote/'+id,
    method: 'get',
  
  })
}

export function GetWZdetail(id){
  return request({
    url: 'wx/article-list/'+id,
    method: 'get',
  
  })
}
export function GetSearchWZ(params){
  return request({
    url: 'wx/article-down-vote',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/CasualPatting.js


// WEBPACK FOOTER //
// ./src/api/CasualPatting.js